import { useState } from "react";
import "./App.css";
import "./pages/LaxmiPriyaRealEstate.css";
import "./pages/MarutiFlyAshBricks.css";
import axios from "axios";
import { Building2, Warehouse, PartyPopper, Phone, Mail, MapPin, CheckCircle2, Leaf, Award, Users, ArrowRight, Menu, X, LucideBuilding2, HomeIcon } from "lucide-react";
import { Button } from "./components/ui/button";
import { Input } from "./components/ui/input";
import { Textarea } from "./components/ui/textarea";
import { toast } from "sonner";
import { Toaster } from "./components/ui/sonner";
import { useNavigate } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// If BACKEND_URL is not provided, fall back to a relative `/api` endpoint
const API = BACKEND_URL ? `${BACKEND_URL}/api` : `/api`;

function App() {
  const navigate = useNavigate();
  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const ventures = [
    {
      icon: <Building2 className="w-12 h-12" />,
      title: "Laxmipriya Realestate",
      description: "High-quality residential and commercial property solutions with over 5 years of expertise. Serving builders, landlords, and homeowners.",
      features: ["30-acre plotting in Nuapatna", "100+ satisfied customers", "LP NITYAM NEST - Banamalipur", "LP SRISTIKA VALLEY - Nuapatana"],
      color: "from-blue-500 to-cyan-500"
    },
    {
      icon: <Warehouse className="w-12 h-12" />,
      title: "Maruti Flyash Bricks",
      description: "Brand: 5 BRICKS - Eco-friendly fly ash bricks that reduce soil depletion and air pollution. Setting industry standards in durability.",
      features: ["Eco-friendly production", "Custom sizes available", "State-of-the-art facility", "Energy-efficient process"],
      color: "from-green-500 to-emerald-500"
    },
    {
      icon: <PartyPopper className="w-12 h-12" />,
      title: "Padmabati Mandap",
      description: "Premium event venue designed for weddings, celebrations, and corporate functions with quality amenities and versatile space.",
      features: ["Premium facilities", "Versatile spaces", "All event types", "Accessible location"],
      color: "from-orange-500 to-amber-500"
    },
     {
      icon: <LucideBuilding2 className="w-12 h-12" />,
      title: "Ventures - Property Lease",
      description: "School rent, Marbleshowrooms rent, Godown rents etc.",
      features: ["School rent", "Marbleshowrooms rent", "Godown rents"],
      color: "from-orange-500 to-amber-500"
    },
     {
      icon: <HomeIcon className="w-12 h-12" />,
      title: "Maruti Ply",
      description: "Maruti Ply is one of the newest ventures under Maruti Group launched to meet rising demands of contruction and interior furnishing industry.",
      features: ["Plywood", "Laminates", "WPC Ply", "Hardware"],
      color: "from-orange-500 to-amber-500"
    }

  ];

  const stats = [
    { icon: <Award className="w-8 h-8" />, value: "35+", label: "Years Experience" },
    { icon: <Users className="w-8 h-8" />, value: "100+", label: "Happy Clients" },
    { icon: <Leaf className="w-8 h-8" />, value: "100%", label: "Eco-Friendly" },
    { icon: <Building2 className="w-8 h-8" />, value: "3", label: "Core Ventures" }
  ];

  const clientele = [
    "East Coast Railway",
    "AEC",
    "IMFA",
    "Mother's Public School",
    "SCB Medical"
  ];

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Send the message server-side via /send-whatsapp. This requires the server
      // (server/index.js in the repo) to be running and configured with
      // WHATSAPP_TOKEN and WHATSAPP_PHONE_NUMBER_ID.
      const parts = [];
      if (contactForm.name) parts.push(`Name: ${contactForm.name}`);
      if (contactForm.email) parts.push(`Email: ${contactForm.email}`);
      if (contactForm.phone) parts.push(`Phone: ${contactForm.phone}`);
      if (contactForm.subject) parts.push(`Subject: ${contactForm.subject}`);
      if (contactForm.message) parts.push(`Message: ${contactForm.message}`);
      const body = parts.length ? `Hello, I'm contacting you via the website. ${parts.join(' | ')}` : "Hello, I'm interested in your services. Could you please contact me?";

      // Post to local server endpoint which will call the WhatsApp Cloud API
      const resp = await axios.post('/send-whatsapp', {
        to: whatsappNumber,
        message: body
      });

      if (resp?.data?.success) {
        toast.success('Message sent via WhatsApp API.');
        setContactForm({ name: "", email: "", phone: "", subject: "", message: "" });
      } else {
        toast.error('Failed to send via WhatsApp API.');
        console.error('Unexpected response from /send-whatsapp:', resp?.data);
      }
    } catch (err) {
      console.error('send-whatsapp failed:', err?.response?.data || err.message || err);
      const errMsg = err?.response?.data?.message || err?.response?.data || err?.message || 'Failed to send message.';
      toast.error(`Failed to send: ${errMsg}`);
    } finally {
      setLoading(false);
    }
  };

  const whatsappNumber = "918861229643"; // country code +91 + local number (no +)
  // `openWhatsApp` helper was removed because the contact UI uses an anchor link
  // (keeps behavior consistent and avoids popup blockers). Keep `whatsappNumber` for the anchor.

  const handleVentureInterest = async (ventureName) => {
    // Navigate to dedicated page for Laxmi Priya Real Estate
    if (ventureName === "Laxmipriya Realestate") {
      navigate("/laxmi-priya-real-estate");
      return;
    }
    if (ventureName === "Maruti Flyash Bricks") {
      navigate("/maruti-fly-ash-bricks");
      return;
    }
    if (ventureName === "Padmabati Mandap") {
      navigate("/padmabati-mandap");
      return;
    }
    if (ventureName === "Maruti Ply") {
       navigate("/maruti-ply");
      return;
    }
    if (ventureName === "Residential Projects") {
       navigate("/laxmi-priya-real-estate");
      return;
    }

    // For other ventures, show interest form
    const name = prompt("Please enter your name:");
    const email = prompt("Please enter your email:");
    const phone = prompt("Please enter your phone number:");

    if (name && email && phone) {
      try {
        await axios.post(`${API}/venture-interest`, {
          name,
          email,
          phone,
          venture: ventureName
        });
        toast.success("Interest registered! We'll contact you soon.");
      } catch (error) {
        toast.error("Failed to register interest. Please try again.");
        console.error(error);
      }
    }
  };

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileMenuOpen(false);
  };

  return (
    <div className="App">
      <Toaster richColors position="top-right" />
      
      {/* Navigation */}
      <nav className="nav-bar" data-testid="main-navigation">
        <div className="nav-container">
          <div className="nav-logo" data-testid="company-logo">
            <img src={require('src/images/MarutiGroupLogo.jpg')} alt="Maruti Group Logo" className="w-10 h-10" />
            <span className="logo-text">MARUTI GROUP</span>
          </div>
          
          <button 
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>

          <div className={`nav-links ${mobileMenuOpen ? 'active' : ''}`} data-testid="nav-links">
            <button onClick={() => scrollToSection('home')} data-testid="nav-home">Home</button>
            <button onClick={() => scrollToSection('about')} data-testid="nav-about">About</button>
            <button onClick={() => scrollToSection('ventures')} data-testid="nav-ventures">Ventures</button>
            <button onClick={() => scrollToSection('contact')} data-testid="nav-contact">Contact</button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section" id="home" data-testid="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title" data-testid="hero-title">
            Building Sustainable Future Since 1987
          </h1>
          <p className="hero-subtitle" data-testid="hero-subtitle">
            Leading provider of eco-friendly construction materials, premium real estate solutions, and exceptional event venues
          </p>
          <div className="hero-buttons">
            <Button 
              size="lg" 
              className="hero-btn-primary"
              onClick={() => scrollToSection('ventures')}
              data-testid="explore-ventures-btn"
            >
              Explore Our Ventures
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="hero-btn-secondary"
              onClick={() => scrollToSection('contact')}
              data-testid="contact-us-btn"
            >
              Contact Us
            </Button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section" data-testid="stats-section">
        <div className="stats-container">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card" data-testid={`stat-card-${index}`}>
              <div className="stat-icon">{stat.icon}</div>
              <div className="stat-value" data-testid={`stat-value-${index}`}>{stat.value}</div>
              <div className="stat-label" data-testid={`stat-label-${index}`}>{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section" id="about" data-testid="mission-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title" data-testid="mission-title">Our Mission</h2>
            <div className="section-divider"></div>
          </div>
          <div className="mission-content">
            <div className="mission-card" data-testid="mission-card">
              <Leaf className="mission-icon" />
              <h3 className="mission-heading">Sustainable Innovation</h3>
              <p className="mission-text">
                We provide innovative, eco-friendly solutions across industries, contributing to sustainable growth while prioritizing quality and customer satisfaction. Since our founding in 1987, we've been committed to reducing environmental impact through our eco-friendly fly ash bricks and sustainable construction practices.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Ventures Section */}
      <section className="ventures-section" id="ventures" data-testid="ventures-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title" data-testid="ventures-title">Core Ventures</h2>
            <div className="section-divider"></div>
          </div>
          <div className="ventures-grid">
            {ventures.map((venture, index) => (
              <div key={index} className="venture-card" data-testid={`venture-card-${index}`}>
                <div className={`venture-icon-wrapper bg-gradient-to-br ${venture.color}`}>
                  {venture.icon}
                </div>
                <h3 className="venture-title" data-testid={`venture-title-${index}`}>{venture.title}</h3>
                <p className="venture-description" data-testid={`venture-description-${index}`}>{venture.description}</p>
                <ul className="venture-features">
                  {venture.features.map((feature, fIndex) => (
                    <li key={fIndex} className="venture-feature" data-testid={`venture-feature-${index}-${fIndex}`}>
                      <CheckCircle2 className="w-5 h-5 text-green-500" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <Button 
                  className="venture-btn"
                  onClick={() => handleVentureInterest(venture.title)}
                  data-testid={`venture-interest-btn-${index}`}
                >
                  Learn More
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Clientele Section */}
      <section className="clientele-section" data-testid="clientele-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title" data-testid="clientele-title">Trusted by Leading Organizations</h2>
            <div className="section-divider"></div>
          </div>
          <div className="clientele-grid">
            {clientele.map((client, index) => (
              <div key={index} className="client-card" data-testid={`client-card-${index}`}>
                <Award className="w-8 h-8 text-blue-500" />
                <span>{client}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section" id="contact" data-testid="contact-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title" data-testid="contact-title">Get In Touch</h2>
            <div className="section-divider"></div>
          </div>
          <div className="contact-grid">
            <div className="contact-info" data-testid="contact-info">
              <div className="api-debug" style={{ marginTop: '0.5rem', fontSize: '0.85rem', color: '#666' }}>
                API POST URL: {`${API}/contact`}
              </div>
              <h3 className="contact-info-title">Contact Information</h3>
              <div className="contact-info-items">
                <div className="contact-info-item" data-testid="contact-location">
                  <MapPin className="w-6 h-6" />
                  <div>
                    <strong>Address</strong>
                    <p>Nuapatna, Cuttack</p>
                  </div>
                </div>
                <div className="contact-info-item" data-testid="contact-phone">
                  <Phone className="w-6 h-6" />
                  <div>
                    <strong>Phone</strong>
                    <p>9692811666 / 7008495588</p>
                  </div>
                </div>
                <div className="contact-info-item" data-testid="contact-email">
                  <Mail className="w-6 h-6" />
                  <div>
                    <strong>Email</strong>
                    <p>smruti@fivestarbricks.in</p>
                  </div>
                </div>
              </div>
              <div className="contact-whatsapp" style={{ marginTop: '1rem' }}>
                {(() => {
                  const parts = [];
                  if (contactForm.name) parts.push(`Name: ${contactForm.name}`);
                  if (contactForm.phone) parts.push(`Phone: ${contactForm.phone}`);
                  if (contactForm.subject) parts.push(`Subject: ${contactForm.subject}`);
                  if (contactForm.message) parts.push(`Message: ${contactForm.message}`);
                  const body = parts.length ? `Hello, I'm contacting you via the website. ${parts.join(' | ')}` : "Hello, I'm interested in your services. Could you please contact me?";
                  const href = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(body)}`;
                  return (
                    <Button asChild className="whatsapp-btn">
                      <a href={href} target="_blank" rel="noopener noreferrer">Send WhatsApp Message</a>
                    </Button>
                  );
                })()}
              </div>
            </div>
            <form className="contact-form" onSubmit={handleContactSubmit} data-testid="contact-form">
              <Input
                placeholder="Your Name"
                value={contactForm.name}
                onChange={(e) => setContactForm({...contactForm, name: e.target.value})}
                required
                data-testid="contact-form-name"
              />
              <Input
                type="email"
                placeholder="Your Email"
                value={contactForm.email}
                onChange={(e) => setContactForm({...contactForm, email: e.target.value})}
                required
                data-testid="contact-form-email"
              />
              <Input
                type="tel"
                placeholder="Your Phone"
                value={contactForm.phone}
                onChange={(e) => setContactForm({...contactForm, phone: e.target.value})}
                required
                data-testid="contact-form-phone"
              />
              <Input
                placeholder="Subject"
                value={contactForm.subject}
                onChange={(e) => setContactForm({...contactForm, subject: e.target.value})}
                required
                data-testid="contact-form-subject"
              />
              <Textarea
                placeholder="Your Message"
                value={contactForm.message}
                onChange={(e) => setContactForm({...contactForm, message: e.target.value})}
                required
                rows={4}
                data-testid="contact-form-message"
              />
              <Button 
                type="submit" 
                className="submit-btn" 
                disabled={loading}
                data-testid="contact-form-submit"
              >
                {loading ? "Sending..." : "Send Message"}
              </Button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer" data-testid="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img src={require('src/images/MarutiGroupLogo.jpg')} alt="Maruti Group Logo" className="w-10 h-10" />
              <span>MARUTI GROUP</span>
            </div>
            <p className="footer-text">
              Building sustainable futures since 1987. Committed to quality, innovation, and customer satisfaction.
            </p>
          </div>
          <div className="footer-bottom">
            <p>© 2025 Maruti Group. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;